module.exports = __webpack_public_path__ + "static/img/login-Img2.d812df2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/modularMain/login-Img2.png
// module id = jET2
// module chunks = 31